import { vec2 } from "@tlaukkan/tsm";
import { System } from "ecsy";
import { applyForce } from "../box2dUtils";
import { Transform, Magnet, Submerged } from "../components";

export class MagnetSystem extends System {
	execute() {
		this.queries.magnets.results.forEach(entity => {
			const magnet = entity.getComponent(Magnet);
			const transform = entity.getComponent(Transform);

			const hits = magnet.targets;
			const step = getStepNumber();
			for (const hit of hits) {
				if (hit.hasComponent(Submerged)) return;

				const target = hit.getComponent(Transform).position.copy();
				const force = vec2.direction(transform.position, target).scale(magnet.force);
				applyForce(hit, force);
				magnet.lastActivationStep = step;
			};
		});
	}
}

MagnetSystem.queries = {
	magnets: { components: [Transform, Magnet], listen: { added: true } },
};
